export default __webpack_public_path__ + "static/shippingManagementVp1-ca694d0ead0d8fd2f2594f4ec2000b13.png";